export type LoginLocationState = Readonly<{
  redirectUrl?: string;
  from?: Location;
}>;

export const getPostLoginDestination = (state?: LoginLocationState | null) =>
  state?.redirectUrl ?? state?.from ?? '/loading';
